module.exports = __webpack_public_path__ + "img/fsmp.1caff174.svg";